import { request } from './request'

function apiUrl(path) {
  return process.env.NODE_ENV === 'production' ? `/api/blog/${path}` : `/blog/${path}`;
}

export function queryDeviceActivation(sn) {
  return request({
    url: apiUrl('device/activation/info/'),
    method: 'post',
    timeout: 20000,
    data: { sn }
  })
}

export function activateDevice(sn, activateType) {
  return request({
    url: apiUrl('device/activation/activate/'),
    method: 'post',
    timeout: 30000,
    data: {
      sn,
      activateType
    }
  })
}
